
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { TicketStatus, TicketStatusTypes } from "./types";

export const ChangeStatusModal = forwardRef<any, { data: TicketStatus, ticketstatusTypes: TicketStatusTypes[], id?: string }>((
    { data, ticketstatusTypes, id }, ref
) => {
    const localize = useSelector(getLocalized);

    return <div>
        <Form
            ref={ref}
            formData={data}
        >
            <GroupItem>

                <SimpleItem
                    cssClass={"ticket-lookup"}
                    dataField={"ticketId"}
                    editorType={"dxLookup"}
                    label={{
                        text : localize.getString("ticketStatusType")
                    }}
                    editorOptions={
                        {
                            searchEnabled: true,
                            items: ticketstatusTypes,
                            displayExpr: "Name",
                            valueExpr: "Id",
                            placeholder: "Select",
                            onValueChanged: (e: any) => {

                                data.ticketId = id
                                data.ticketStatusId = e.value


                            }
                        }

                    }

                >

                </SimpleItem>
            </GroupItem>
        </Form>
    </div>
})